<fc-article-header [content]="content" [analyticsMode]="analyticsMode">
    <div [ngClass]="content.accentTheme">
        <article class="fc-heading-only-article" *ngFor="let c of content.components; let i = index" >
            <div class="fc-index">{{i + 1}}</div>
            <h3 class="fc-header"><a [fcContentLink]="c" [analyticsMode]="analyticsMode" [mode]="'block'" [innerHtml]="c.heading"></a></h3>
        </article>
    </div>
</fc-article-header>